// 8.3.8 Interview Practice UI (merged as `iv`).
const iv = {
 "scriptLatin": "Latino",
 "scriptCyrillic": "Cirílico",
 "tabNew": "Nuevo chat",
 "tabChats": "Chats",
 "tabInterview": "Entrevista",
 "cardTitle": "Práctica de entrevistas",
 "cardSub": "Practica una conversación importante antes de que ocurra.",
 "promise": "Practica las conversaciones que importan antes de que ocurran.",
 "support": "Elige una entrevista o describe la tuya. Tu entrevistador se adapta a tu nivel y a tus respuestas.",
 "fam": {
  "work": "Trabajo",
  "education": "Estudios",
  "travel": "Viajes y trámites",
  "public": "Profesional",
  "personal": "Personal",
  "custom": "Personalizada"
 },
 "sc": {
  "job": "Entrevista de trabajo",
  "internship": "Entrevista de prácticas",
  "promotion": "Entrevista de ascenso",
  "freelance": "Presentación a un cliente freelance",
  "networking": "Networking",
  "university": "Admisión universitaria",
  "scholarship": "Entrevista de beca",
  "oral_exam": "Examen oral escolar",
  "language_exam": "Examen oral de idiomas",
  "visa": "Entrevista tipo visado",
  "travel_questions": "Preguntas en un viaje",
  "hotel_problem": "Problema en el hotel o viaje",
  "media": "Entrevista en medios/pódcast",
  "presentation_qa": "Preguntas tras una presentación",
  "client_meeting": "Reunión con un cliente",
  "pro_intro": "Presentación profesional",
  "housing": "Piso/vivienda",
  "doctor": "Cita con el médico",
  "meet_new": "Conocer a alguien",
  "difficult": "Conversación difícil",
  "custom": "Describe la tuya"
 },
 "contextLabel": "¿Qué debería saber el entrevistador?",
 "contextPh": "Opcional: puesto, empresa, materia, lo que te preocupa…",
 "customPh": "Describe tu entrevista, p. ej. «Mañana tengo una entrevista de recepcionista de hotel en Madrid».",
 "length": "Duración",
 "quick": "Rápida — unas 5 preguntas",
 "standard": "Estándar — unas 10 preguntas",
 "deep": "A fondo — unas 15 preguntas",
 "style": "Estilo de práctica",
 "supportive": "Amable",
 "realistic": "Realista",
 "challenging": "Exigente",
 "start": "Empezar entrevista",
 "starting": "Preparando a tu entrevistador…",
 "progress": "{n} de {total}",
 "answerPh": "Tu respuesta…",
 "send": "Enviar",
 "type": "Escribir",
 "speak": "Hablar",
 "listen": "Escuchar",
 "help": "Ayúdame a decirlo",
 "helpPh": "Escribe lo que quieres decir, en cualquier idioma",
 "helpGo": "Mostrar",
 "helpNote": "Úsalo como modelo y luego escribe tu propia respuesta.",
 "finished": "Gracias, la entrevista ha terminado. Veamos qué tal te ha ido.",
 "seeReport": "Ver mi valoración",
 "building": "Preparando tu valoración…",
 "overall": "En general",
 "areasT": "Áreas de mejora",
 "areas": {
  "clarity": "Claridad",
  "vocabulary": "Vocabulario",
  "grammar": "Gramática",
  "naturalness": "Naturalidad",
  "effectiveness": "Eficacia en la entrevista"
 },
 "lv": {
  "strong": "Sólido",
  "developing": "En progreso",
  "needs_practice": "Necesita práctica"
 },
 "worked": "Lo que funcionó",
 "improve": "Para mejorar",
 "better": "Mejores formas de decirlo",
 "phrases": "Frases útiles",
 "save": "Guardar",
 "saved": "Guardado en Vocab",
 "history": "Tus entrevistas",
 "empty": "Aún no tienes entrevistas.",
 "resume": "Continuar",
 "startOver": "Empezar de nuevo",
 "view": "Ver",
 "st": {
  "active": "En curso",
  "answered": "Lista para valorar",
  "completed": "Completada"
 },
 "retry": "Algo salió mal. Tus respuestas están a salvo; inténtalo de nuevo.",
 "retryBtn": "Reintentar",
 "newInterview": "Nueva entrevista",
 "back": "Volver",
 "suggest": "¿Tienes una conversación importante pronto?",
 "suggestBtn": "Prueba la práctica de entrevistas",
 "dismiss": "Descartar",
 "recording": "Grabando… toca para parar",
 "transcribing": "Transcribiendo…",
 "micFail": "La voz no funciona; escribe tu respuesta.",
 "disclaimer": "Solo práctica de idioma: no es asesoramiento legal, migratorio, médico ni de contratación.",
 "describeFirst": "Describe primero tu entrevista."
};
export default iv;
